import Vue from 'vue'

Vue.prototype.$perms = {
  account_index: 1,
  account_show: 2,
  account_create: 3,
  account_edit: 4,
  account_destroy: 5,
  device_index: 6,
  device_show: 7,
  device_create: 8,
  device_edit: 9,
  device_destroy: 10,
  config_index: 11,
  config_show: 12,
  config_create: 13,
  config_edit: 14,
  config_destroy: 15,
  user_index: 16,
  user_show: 17,
  user_create: 18,
  user_edit: 19,
  user_destroy: 20

};


//https://stackoverflow.com/questions/1436438/how-do-you-set-clear-and-toggle-a-single-bit-in-javascript
Vue.prototype.$checkPerm = function (bit) {
  return (this.$store.getters.getPerms & (1 << bit - 1)) === 0 ? false : true;
};


Vue.prototype.$can = function (model, action) {
  let perm = model + '_' + action;
  let bit = this.$perms[perm];

/*
 let ans = (perms & (1 << (bit -1) )) ;

  if ans == 0 then the bit is not set ==> return false
  if ans != 0 then the bit is set. ans will be = 2POW(bit-1) ==> return true

  e.g. checking for 8th bit in 130402 and 1048575
  130402 & (1 << (8-1)) == 0;  bit is not set ==>return false
  1048575 & (1 << (8 -1)) == 128; bit is set ==> return true  
*/
//console.log('CAN: ' + (this.$store.getters.getPerms & (1 << bit - 1)) );
  return (this.$store.getters.getPerms & (1 << bit - 1)) === 0 ? false : true;
};

